<template>
  <div
    class="lane-container"
    v-if="!hide_during_search && ( !commitment.meta.deleted || showArchived )"
    @mouseover="onMouseover"
    @mouseleave="onMouseleave"
  >
    <div :class="{
      'lane': true,
      'lane--is-deleted': commitment.meta.deleted,
    }">
      <div class="list lane-drag-handle" v-if="lane && commitment.$ready">
        <KanbanListHeader
          v-if="showHeader"
          :goalId="goalId"
          :commitmentId="lane.$id"
          :commitmentFinishDate="finishDates && finishDates['commitment'] || 0"
          :activeTask="active_task"
          :durationPlanned="durationSumUnfiltered"
        />

        <!-- loading: {{loading}} -->
        <!-- <pre>tasklist_this_lane: {{ tasklist_this_lane }}</pre> -->
        <!-- <pre>tasklist_this_lane_filtered: {{ tasklist_this_lane_filtered }}</pre> -->
        <!-- <pre>tasksInSession: {{ tasksInSession }}</pre> -->
        <!-- <pre>itemCount_planned: {{ itemCount_planned }}</pre> -->
        <!-- <pre>itemCount_planned: {{ itemCount_planned }}</pre> -->
        <!-- <pre>itemCount_unplanned: {{ itemCount_unplanned }}</pre> -->
        <!-- <pre>isDayplan: {{ isDayplan }}</pre> -->
        <!-- <pre>show_backlog: {{ show_backlog }}</pre> -->
        <!-- <pre>lane: {{ lane }}</pre> -->
        <!-- <pre>commitment: {{ commitment }}</pre> -->
        <!-- <pre>goalId: {{ goalId }}</pre> -->
        <!-- <pre>commitment.type: {{ commitment.type }}</pre> -->
        <template v-if="(commitment.type === 'TASKLIST' || commitment.type === 'BACKLOG' || commitment.type === 'TIME_BASED_TASKLIST' || commitment.type === 'SEQUENCE') && tasksInSessionWithFrom">
          <template v-if="!commitment.meta.deleted">
            <template v-if="commitment.access.allow_to_see_tasks">
              <!-- v-if="tasklist.$readySome" -->
              <task-list
                ref="tasklist"
                :list-is-editable="commitment.access.allow_to_edit_tasks"
                :goal-id="goalId"
                :list-id="lane.$id"
                :tasklist="tasklist_this_lane_filtered"
                :tasklistAll="tasklist_this_lane"
                :allow-to-reorder="true"
                :show-prop-task-height="showPropTaskHeight"
                :assigned-user-id="assigned_user_id"
                :finishDates="finishDates || null"
                :activeTask="active_task"
                @drag-start="onDragStart"
                @drag-end="onDragEnd"
                :tasksInSession="tasksInSessionWithFrom"
                :isDayplan="isDayplan"
                :sessionId="sessionId"
                listType="planned"
                :showReducedDayplan="showReducedDayplan"
                :itemCountPlanned="itemCount_planned"
              />

              <!-- <div style="width: 300px; margin-left: 10px; margin-top: 0.5em"></div> -->

              <div
                v-if="tasksInSession && !showReducedDayplan"
                style="display: flex; justify-content: space-between; "
                :class="{
                  'mt-2 mb-0': true,
                  'kanban-list-space-right': isDayplan,
                }">
                <el-button
                  v-if="!show_backlog /* && itemCount_unplanned > 0 */"
                  @click="show_backlog = true"
                  style="font-weight: bold; color: #666666; border-radius: 5px">
                  Show backlog ({{ itemCount_unplanned === 1 ? '1 task' : itemCount_unplanned + ' tasks'}})
                </el-button>
                <el-button
                  v-if="show_backlog"
                  @click="show_backlog = false"
                  style="font-weight: bold; color: #666666;">
                  Hide backlog
                </el-button>
                <el-button @click="onAddTask()" style="font-weight: bold; color: #409eff; ">
                  <!--<font-awesome-icon icon="plus" class="mr-1"/>-->Create task
                </el-button>
              </div>

              <task-list
                v-if="show_backlog && !showReducedDayplan"
                class="mt-2"
                ref="tasklist_session"
                :list-is-editable="commitment.access.allow_to_edit_tasks"
                :goal-id="goalId"
                :list-id="lane.$id"
                :tasklist="tasklist_this_lane_filtered_unplanned"
                :tasklistAll="tasklist_this_lane"
                :allow-to-reorder="true"
                :show-prop-task-height="showPropTaskHeight"
                :assigned-user-id="assigned_user_id"
                :finishDates="finishDates || null"
                :activeTask="active_task"
                @drag-start="onDragStart"
                @drag-end="onDragEnd"
                :tasksInSession="tasksInSession"
                :isDayplan="isDayplan"
                :sessionId="sessionId"
                :unplannedOnly="true"
                listType="unplanned"
              />

              <footer v-if="!showReducedDayplan">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <div v-if="!tasksInSession">
                    <el-button @click="onAddTask()" style="font-weight: bold; color: #409eff; ">
                      <font-awesome-icon icon="plus" class="mr-1"/>Add task
                    </el-button>
                  </div>

                  <!--
                  <template v-if="!(tasksInSession && !show_backlog)"></template>
                  <div v-if="active_task_found_in_lane" style="display: flex; flex-direction: column">
                    <KanbanListDuration
                      :durationSum="durationSum"
                      :activeTask="active_task"
                      :itemCount="itemCount"
                      :itemCountTotal="itemCountTotal"
                    />
                  </div>
                  -->

                  <template v-if="isDayplan && show_backlog">
                    <div class="small">
                      &thinsp;{{itemCount}} of {{itemCountTotal}} items selected
                    </div>
                    <div class="small kanban-list-space-right">
                      &Sigma;&thinsp;{{ durationSum | hoursMinutes }}
                    </div>
                  </template>
                  <template v-if="!isDayplan">
                    <span class="small">
                      &Sigma;&thinsp;{{ durationSum | hoursMinutes }}&emsp;
                      #&thinsp;{{itemCount}}
                    </span>
                  </template>

                </div>
              </footer>

            </template>
            <template v-else>
              <div class="list-inner">
                <div class="item m-4 text-center">You don't have access to this list.</div>
              </div>
              <footer></footer>
            </template>
          </template>
          <template v-else>
            <footer></footer>
          </template>
        </template>

        <template v-if="commitment.type === 'SEQUENCE' && 0">
          <!-- TODO: Don't show task list in kanban! -->
          <task-list
            ref="tasklist"
            :list-is-editable="commitment.access.allow_to_edit_tasks"
            :goal-id="goalId"
            :list-id="lane.$id"
            :tasklist="tasklist_this_lane_filtered"
            :allow-to-reorder="true"
            :show-prop-task-height="showPropTaskHeight"
            :assigned-user-id="assigned_user_id"
            :finishDates="finishDates || null"
            :activeTask="active_task"
            @drag-start="onDragStart"
            @drag-end="onDragEnd"
            :tasksInSession="tasksInSession"
            :isDayplan="isDayplan"
            :sessionId="sessionId"
          />

          <div class="list-inner text-center">
            <a
              href="#"
              @click.prevent="hide_sequence = !hide_sequence"
            >{{hide_sequence ? 'show sequence ...' : 'hide'}}</a>
            <!-- | <router-link :to="{ name: 'edit_sequence', params: { sequenceId: commitment.sequenceId } }">edit sequence</router-link> -->
          </div>
          <div class="list-inner p-2">
            <!-- <pre class="mini-pre">commitment.sequenceId: {{ commitment.sequenceId }}</pre> -->
            <!-- <pre class="mini-pre">commitment.templateRepeat: {{ commitment.templateRepeat }}</pre> -->
            <div v-if="!hide_sequence">
              <template v-if="commitment.sequenceId">
                <PreviewSequence
                  :sequence-id="commitment.sequenceId"
                  :user-repeat="commitment.templateRepeat"
                />
              </template>
              <template v-else>No sequence assigned</template>
            </div>
          </div>
          <footer></footer>
        </template>

        <template v-if="commitment.type === 'MAGICLIST'">
          <div class="list-inner p-2">MAGICLIST (TODO)</div>
          <footer></footer>
        </template>

        <template v-if="commitment.type === 'HABIT'">
          <!-- TODO: component -->
          <div class="list-inner p-2">
            <div class="text-center h5">
              <hr>
              {{commitment.habitNegation === 'DO' ? "Do" : "Don't do"}}
              "{{commitment.meta.name}}"
              {{commitment.habitRepeatPattern.toLowerCase().replace('_', ' ')}}
              <template
                v-if="commitment.habitRepeatDaily > 1"
              >{{commitment.habitRepeatDaily}} times</template>
              <template v-if="commitment.habitWeekdays !== 'xxxxxxx'">
                on
                <WeekdaySelectorInline size="mini" v-model="commitment.habitWeekdays" @save=";"/>
              </template>
              <!-- TODO: show streak (InlineStreak.vue) -->
            </div>
            <!-- <pre class="mini-pre">{{commitment}}</pre> -->
          </div>
          <footer></footer>
        </template>

        <template v-if="commitment.type === 'AMOUNT'">
          <!-- TODO: component -->
          <div class="list-inner p-2">
            <div class="text-center h5">
              <hr>
              <template v-if="commitment.amountType === 'MONEY'">Save a certain amount of money</template>
              <template v-if="commitment.amountType === 'WEIGHT'">Loose or gain weight</template>
              <template v-if="commitment.amountType === 'WATER'">Drink certain amount of water</template>
              <template v-if="commitment.amountType === 'OTHER'">{{comitment.meta.name}}</template>
              <!-- TODO: support more / generic templates -->
              <hr>You're currently at
              <em class="d-block h2 mt-2">{{commitment.amountCurrent}}</em>
              <hr>You're goal is
              <em class="d-block h2 mt-2">{{commitment.amountTarget}}</em>
            </div>
          </div>
          <footer></footer>
        </template>

        <template v-if="commitment.type === 'TRELLO'">
          <div class="list-inner p-2">TRELLO (TODO)</div>
          <footer></footer>
        </template>

        <template v-if="!commitment.type">
          <div class="list-inner">
            <div class="item p-4">
              <!-- TODO: This also occurs, when commitment is deleted -->
              <!-- check if we're deleting and then don't show debug infos -->
              Invalid commitment type: '{{commitment.type}}'
              <pre class="mini-pre" v-if="SHOW_DEBUG">{{commitment}}</pre>
            </div>
          </div>
          <footer></footer>
        </template>
      </div>
      <div v-else class="list">
        <header>
          <div class="text-center p-4">Loading...</div>
        </header>
        <footer></footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import KanbanListHeader from "./KanbanListHeader";
// import KanbanListDuration from "./KanbanListDuration";
import TaskList from "./TaskList";
import PreviewSequence from "./PreviewSequence";
import FuseSearch from "@/components/Mixins/FuseSearch";
//import { mapGetters } from "vuex";
import debounce from "lodash.debounce";
import util from "@/util";
//import clonedeep from 'lodash.clonedeep'

export default {
  name: "KanbanList",
  mixins: [FuseSearch],
  props: {
    goalId: {
      type: String,
      default: null,
    },
    lane: {
      type: Object,
      default: null,
    },
    showFinished: {},
    showArchived: {},
    showPropTaskHeight: {},
    searchString: {},
    filterByLabel: {},
    finishDates: {
      type: Object,
      default: null,
    },
    showHeader: { default: true },
    loading: { type: Boolean },
    sessionFrom: {
      type: Number,
      default: null,
    },
    sessionTo: {
      type: Number,
      default: null,
    },
    tasksInSession: {
      type: Array,
    },
    // width: {
    //   type: String,
    // },
    isDayplan: {
      type: Boolean,
    },
    sessionId: {
      type: String,
    },
    showReducedDayplan: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    search_ready: false,
    deleting: false,
    hide_sequence: true /* default for hiding sequences */,
  }),
  created() {
    this.make_cache_debounced = debounce(v => {
      this.makeSearchCache();
      this.setUpFuse({
        keys: ["name", "description"],
      });
      this.search_ready = true;
    }, 1000);
    this.make_cache_debounced();
  },
  watch: {
    tasklist_this_lane: {
      handler(value) {
        if (!value) {
          return;
        }
        this.make_cache_debounced();
      },
    },
    searchString(text) {
      this.search_string = text;
    },
    itemCount_planned(value_new, value_old) {
      /* This watcher will open the backlog, if all items are removed from 'planned' */
      if (
        this.tasklist_this_lane_filtered
        && value_new === 0
        && value_old === 1
        && this.isDayplan) {
        this.show_backlog = true
      }
    },
    itemCount_unplanned(value_new, value_old) {
      /* This watcher will open the backlog, if a new session is added to the dayplan
         (and has a backlog). -> see setBacklogStatus
      */
      // if (this.tasklist_this_lane_filtered
      //   && value_new > 0
      //   && this.itemCount_planned === 0
      //   && this.isDayplan) {
      //   this.show_backlog = true
      // }
    }
  },
  computed: {
    ...mapGetters('dayplanner', [
      'show_backlog_by_session_id',
    ]),
    tasksInSessionWithFrom() {
      if (this.tasksInSession) {
        let tasks = this.tasksInSession.map(task => {
          let item = this.tasklist_this_lane.find(item => item.$id === task.taskId)
          //.sortidx
          let sortidx = -1
          if (item && item.sortidx) {
            sortidx = item.sortidx
          }
          return {
            cachedTitle: task.cachedTitle,
            duration: task.duration,
            taskId: task.taskId,
            from: task.from,
            sortidx: sortidx
          }
        })
        tasks = tasks.filter(item => item.sortidx !== -1).sort(util.sorter.by_sortidx)
        /*let taskDurationTotal = 0;
        for (let i = 0; i < tasks.length; i++) {
          taskDurationTotal += tasks[i].duration;
        }*/
        //let buffer = this.sessionTo - this.sessionFrom - taskDurationTotal;
        let tmpTaskFrom = this.sessionFrom
        for (let i = 0; i < tasks.length && tasks[i] && tasks[i].from; i++) {
          tasks[i].from = tmpTaskFrom;
          tmpTaskFrom += tasks[i].duration //+ Math.floor(buffer / tasks.length);
        }

        tasks = tasks.map(task => {
          return {
            cachedTitle: task.cachedTitle,
            duration: task.duration,
            taskId: task.taskId,
            from: task.from
          }
        })

        return tasks
      } else {
        return []
      }
    },

    hide_during_search() {
      if (this.loading || !this.search_ready) {
        return false;
      }
      if (this.search_string && this.itemCount === 0) {
        return true;
      }
      return false;
    },

    show_backlog: {
      get () {
        return this.show_backlog_by_session_id( this.sessionId );
      },
      set(status) {
        this.setBacklogStatus({ sessionId: this.sessionId, status: status });
      }
    },

    commitment() {
      // xTODO: Careful, this information is only available to some users!!
      // TODO: Rather sync entire list one level highter .subscribeList() and use .getNode here

      // INFO: getNodeFull automatically detects the right user
      return this.$models.commitment.with({ goalId: this.goalId }).getNodeFull(this.lane.$id);
    },

    assigned_user_id() {
      return this.commitment.meta.assignedUserId;
    },

    user_status() {
      if (this.assigned_user_id && this.assigned_user_id !== "") {
        return this.$models.userStatus.subscribeNode(this.assigned_user_id);
      } else {
        return null;
      }
    },

    active_task() {
      if (
        this.user_status.$ready &&
        this.user_status.taskId &&
        this.user_status.taskRecordingStartedAt &&
        this.user_status.taskDuration
      ) {
        return {
          taskId: this.user_status.taskId,
          taskRecordingStartedAt: this.user_status.taskRecordingStartedAt,
          taskDuration: this.user_status.taskDuration,
          goalId: this.user_status.goalId,
        };
      } else {
        return null;
      }
    },

    active_task_found_in_lane() {
      let tasklist = this.tasklist_this_lane;
      let found = false;
      if (tasklist && this.user_status.$ready && this.user_status.taskId) {
        found = tasklist.filter(item => item.$id === this.user_status.taskId).length === 1;
      }
      return found;
    },

    itemCount() {
      return this.tasklist_this_lane_filtered.length;
    },
    itemCountTotal() {
      return this.tasklist_this_lane.length;
    },

    itemCount_planned() {
      return this.itemCount
    },

    itemCount_unplanned() {
      return this.tasklist_this_lane_filtered_unplanned.length;
    },

    durationSumUnfiltered() {
      return this.tasklist_this_lane.reduce((v, p) => p.durationRemaining + v, 0);
    },

    durationSum() {
      return this.tasklist_this_lane_filtered.reduce((v, p) => p.durationRemaining + v, 0);
    },

    tasklist_this_lane_filtered() {
      let tasklist = this.tasklist_this_lane;
      if (this.isDayplan) {
        tasklist = this.tasklist_this_lane.filter(task => task.sessionId)
        if (this.tasksInSession ) {
          tasklist = tasklist
            .filter(task => {
              // TODO: Not very efficient!
              return this.tasksInSession.find(sessionTask => sessionTask.taskId === task.$id)
            })
        }
      } else {
        if (!this.showFinished) {
          tasklist = tasklist.filter(item => !item.done);
        }
        if (!this.showArchived) {
          tasklist = tasklist.filter(item => !item.deleted);
        }
        if (this.filterByLabel) {
          tasklist = tasklist.filter(item => item.label === this.filterByLabel);
        }
        if (this.search_result) {
          tasklist = tasklist.filter(item => this.search_result[item.$id]);
          tasklist.forEach(item => {
            item.matched_text = this.search_result[item.$id].matched_text;
          });
        } else {
          tasklist.forEach(item => {
            item.matched_text = null;
          });
        }
      }
      return tasklist;
    },

    tasklist_this_lane_filtered_unplanned() {
      let tasklist = this.tasklist_this_lane.filter(task => !task.done && !task.sessionId);
      return tasklist;
    },

    tasklist_this_lane() {
      // CAREFUL: Do not trigger before tasks have been loaded

      if (this.loading) {
        return [];
      }

      let all_tasklists = this.$models.task.with({ goalId: this.goalId }).getters.lane_task_list_all_users;

      return all_tasklists[this.lane.$id] || [];
    },
  },
  methods: {
    ...mapActions('dayplanner', [
      'setBacklogStatus',
    ]),

    onMouseover() {
      this.$emit('mouseover-event')
    },
    onMouseleave() {
      this.$emit('mouseleave-event')
    },
    makeSearchCache() {
      this.search_cache = this.tasklist_this_lane;
    },
    // ...mapActions("goal", [
    //   "add_task",
    // ]),

    onAddTask() {
      this.$refs.tasklist.appendNewTask();
      this.$nextTick(() => {
        /* Wait one more tick, until task is created AND focused */
        this.$refs.tasklist.scrollToBottom();
      });
    },

    onAddTaskQuick() {
      /* HACK: Set current goal */
      // this.$store.commit("goal/SET_CURRENT_GOAL", this.goal_id);

      // TODO: Warum Feuerwerk beim hinzufügen von Task?

      this.$api
        .task_create_user({
          member_id: this.assigned_user_id,
          goal_id: this.goalId,
          parent_id: this.lane.$id,
          data: {},
        })
        .then(new_task_id => {
          this.$refs.tasklist.unfocusAllTasks();
          this.$nextTick(() => {
            this.$refs.tasklist.focusOnTask(new_task_id);
            this.$nextTick(() => {
              /* Wait one more tick, until task is created AND focused */
              this.$refs.tasklist.scrollToBottom();
            });
          });

          // TODO: Find TaskListItem and tell it to go in edit mode on heading
        });
    },

    onRemoveCommitment() {
      this.$api.commitment_delete({
        commitment_id: this.lane.$id,
        goal_id: this.goalId,
        is_backlog: this.commitment.type === "BACKLOG",
      });
    },

    onDragStart(item) {
      console.log('KanbanList onDragStart', item)
      this.$emit('drag-start', item)
    },

    onDragEnd(destination) {
      console.log('KanbanList onDragEnd', destination)
      this.$emit('drag-end', destination)
    },
  },
  components: {
    TaskList,
    KanbanListHeader,
    PreviewSequence,
    // KanbanListDuration,
  },
};
</script>

<style>
.lane-container.sortable-ghost .list {
  width: 290px;
  /* margin-left: 10px; */
  /* margin-right: 10px; */

  background-color: rgba(255, 255, 255, 0.5) !important;
  border: 1px dashed black !important;
  padding: 3px !important;
  border-radius: 6px;
}
.lane-container.sortable-ghost .list > * {
  opacity: 0 !important;
}
.kanban .list .search-result strong {
  background-color: yellow;
}
/* .list > header {
  position: relative;
} */
.lane.lane--is-deleted header {
  background: repeating-linear-gradient(-45deg, #f7e2e2, #f7e2e2 5px, #f8f9fa 5px, #f8f9fa 10px);
}
.lane.lane--is-deleted .lane-deleted-info {
  text-align: center;
  font-weight: bold;
}
.kanban-list-space-right {
  margin-right: 24px
}
</style>
